module.exports = __webpack_public_path__ + "img/corn.a1b5aad6.png";